<script setup>
import ArrowToRightSvg from '@/assets/svgs/ArrowToRightSvg.vue'
import InfoSvg from '@/assets/svgs/InfoSvg.vue'
import { ref, computed } from 'vue'

const props = defineProps({
	title: String,
	description: String,
	lastSearchIcon: {
		default: 0,
	},
	isEllipsis: {
		type: Number,
		default: 1,
	},
})

const isClickShow = ref(false)

const countClassAboutApp = computed(() => {
	let classData = ''

	if (props.isEllipsis > 0) {
		classData += 'text__about_app ellipsis_app'
	} else {
		classData += 'text__about_app'
	}
	if (isClickShow.value) classData += ' disable_ellipsis_app'

	return classData
})

function disableElipsis() {
	isClickShow.value = !isClickShow.value
	console.log(1212)
}
</script>

<template>
	<div class="grid-container grid-container-RTL">
		<div class="title-container">
			<div class="title">
				{{ props.title }}
			</div>

			<div class="button-container" v-show="props.isEllipsis">
				<i class="button-container__button-to" @click="disableElipsis()">
					<ArrowToRightSvg />
				</i>

				<!-- <i class="google-material-icons button-container__button-to" @click="disableElipsis()">arrow_forward</i> -->
			</div>
		</div>

		<div class="content">
			<span :class="countClassAboutApp">
				<!-- <span class="text__about_app"  :class="countClass"> -->
				{{ props.description }}
				<i v-if="props.lastSearchIcon">
					<InfoSvg />
				</i>
				<!-- <i class="google-material-icons" v-if="props.lastSearchIcon">info_outline</i> -->
			</span>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.text_ {
	&_about_app {
		font-family: Roboto, Helvetica, Arial, sans-serif;
		font-size: 0.875rem;
		font-weight: 400;
		letter-spacing: 0.0142857143em;
		max-height: 7.5rem;
		line-height: 1.25rem;
		color: var(--data_color_additional_text);

		// display: -webkit-box;
		// -webkit-box-orient: vertical;
		// -webkit-line-clamp: 6;
		// line-clamp: 6;
		// overflow: hidden;
		// text-overflow: ellipsis;
	}
}

.text__about_app {
	white-space: pre-line;
}

.ellipsis_app {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 6;
	line-clamp: 6;
	overflow: hidden;
	text-overflow: ellipsis;
	// color: var(--data_color_additional_text);
}

.disable_ellipsis_app {
	display: unset !important;
	white-space: pre-line;
	-webkit-box-orient: unset !important;
	-webkit-line-clamp: unset !important;
	overflow: auto;
}

.button-container__button-to {
	color: var(--data__common_behind_color);
	// color: rgb(95, 99, 104);
	fill: var(--data__common_behind_color);
	// fill: rgb(95, 99, 104);
	stop-color: var(--data__common_behind_color);
	// stop-color: rgb(95, 99, 104);
	font-size: 20px;
	padding: 2px;
	user-select: none;
	cursor: pointer;
	margin-left: -24px;
}

.button-container__button-to:hover::before {
	content: '';
	position: absolute;
	background-color: rgb(0, 0, 0);
	opacity: 0.04;
	padding: 25px;
	border-radius: 50px;
	transform: translate(-30%, -30%);
}

.grid-container {
	display: grid;
	grid-template-rows: auto 1fr;
	gap: 10px;
	width: 100%;
}

.title-container {
	display: grid;
	grid-template-columns: 1fr 20px;
	align-items: center;
	width: 100%;
}

.title {
	padding: 0 10px;
	font-family: 'Google Sans', Roboto, Arial, sans-serif;
	line-height: 1.5rem;
	font-size: 1.125rem;
	letter-spacing: 0;
	font-weight: 400;
	font-weight: 500;
	display: flex;
	justify-content: space-between;
	font-size: calc(1.125rem * var(--app-font-size));
}

.button-container {
}

.content {
	padding: 10px;
}
</style>
